import { gridGapInRem, oneColumnBreakpoint, twoColumnsBreakpoint } from "@/components/pages/blogOverview/BlogOverview.page.style";
import { colors } from "@/styles/styleVariables";
import { breakpoints } from "@/utils/breakPoints";

import { css } from "@emotion/react";

export const wrapper = css`
  border: 1px solid ${colors.gray["200"]};
  width: 100%;
`;

export const wrapperFeatured = css`
  grid-column: 1/-1;
  display: flex;
  height: min(38vw, 55rem); // height is 38vw, but 55rem is the max height
  @media screen and (max-width: ${twoColumnsBreakpoint}px) {
    height: 50vw;
  }
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    height: unset;
    grid-column: unset;
    display: block;
  }
`;

export const wrapperNotFeatured = css`
  display: flex;
  flex-direction: column;
`;

export const imageWrapper = css`
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const imageWrapperNotFeatured = css`
  width: 100%;
  height: min(20vw, 30rem); // height is 20vw, but 30rem is the max height
  @media screen and (max-width: ${twoColumnsBreakpoint}px) {
    height: 30vw;
  }
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    height: 58vw;
  }
`;

export const imageWrapperFeatured = css`
  width: 58%;
  height: 100%;
  @media screen and (max-width: ${twoColumnsBreakpoint}px) {
    width: calc(50% - ${gridGapInRem / 2}rem);
  }
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    width: 100%;
    height: 58vw;
  }
`;

export const contentWrapper = css`
  padding: 3rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  .title {
    color: ${colors.slate["900"]};
    line-height: 1.2;
    font-size: 2.4rem;
    font-weight: 400;
    margin-bottom: 2rem;
  }
  .excerpt {
    font-weight: 300;
    color: ${colors.slate["600"]};
  }
  .reading-time {
    font-weight: 300;
    color: ${colors.slate["600"]};
  }
  .category {
    font-weight: 500;
    color: ${colors.slate["900"]};
  }
  @media screen and (max-width: ${breakpoints.mobile500}px) {
    padding: 2rem;
  }
`;

export const contentWrapperFeatured = css`
  flex: 1;
  height: 100%;
  .title {
    font-weight: 600;
    font-size: clamp(3rem, 3.6vw, 4rem);
  }
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    height: unset;
    flex: unset;
  }
`;

export const contentWrapperNotFeatured = css`
`;

export const categoryAndTitleWrapper = css`
  margin-top: 5rem;
`;
